import React, { useContext } from 'react'
import PropTypes from "prop-types"
import { RichText } from 'prismic-reactjs'
import { ThemeProvider } from "styled-components"

import { getLinkPropsFromReference } from '../../utils/link'

import { RichLinks, RichContent } from '../../utils/html'

import { getTheme } from '../../theme/theme'

import PageMetaContext from '../../context/page-meta-context';

import SectionContainer from '../section-container'
import SectionHeader from '../section-header'

import { Inner, Label, Heading, Text, ContentContainer, TableContainer, TableContent, TableHead, TableBody, TableRow, TableColumn, RowLink, LinkColumn } from './table.styles'


const Table = ({label,heading,text,color,overlap,overlapSmall,items,...props}) => {
	const meta = useContext(PageMetaContext);

	const hasLinks = items.some(row => row.row_link);

	let columns = [];
	items.forEach(row => [1,2,3,4].forEach(col => {
		if(row[`column${col}`] && col > columns.length){
			columns.push(`column${col}`)
		}
	}))

	return (
		<ThemeProvider theme={(theme) => ({...theme,...getTheme(color)})}>
			<SectionContainer overlap={overlap} overlapSmall={overlapSmall}>
				<Inner>
					<ContentContainer>
						{label && <Label>{label}</Label>}
						{heading && <Heading><RichContent render={heading} /></Heading>}
						{text && <Text><RichContent render={text} /></Text>}
					</ContentContainer>
					<TableContainer>
						<TableContent>
							<TableHead>
								<TableRow>
									{columns.map((column,c) => {
										if(props[`${column}_heading`]){
											return <TableColumn key={c}>{props[`${column}_heading`]}</TableColumn>
										}
										return null;
									})}
									{hasLinks && <TableColumn />}
								</TableRow>
							</TableHead>
							<TableBody>
								{items.map((row,r) => (
									<TableRow key={r}>
										{columns.map((column,c) => {
											if(row[column]){
												return <TableColumn key={c}>{row[column]}</TableColumn>
											}
											return null;
										})}

										{hasLinks ? (row.row_link ? 
											<LinkColumn>
												<RowLink {...getLinkPropsFromReference(row.row_link)}>
													<svg width="9" height="15" viewBox="0 0 9 15" fill="none" xmlns="http://www.w3.org/2000/svg">
														<path d="M1 1L7.5 7.5L1 14" stroke="#4A90F7" />
													</svg>
												</RowLink>
											</LinkColumn>
										:
											<LinkColumn />
										) : null}
									</TableRow>
								))}
							</TableBody>
						</TableContent>
					</TableContainer>
				</Inner>
			</SectionContainer>
		</ThemeProvider>
	)
}

export default Table;